"use client";

import { LoaderCircle } from "lucide-react";
import { cn } from "@/lib/utils"; // ShadCN's className utility

interface SpinnerProps {
  size?: number;
  className?: string;
}

export function Spinner({ size = 24, className }: SpinnerProps) {
  return (
    <LoaderCircle
      className={cn("text-text-brand-primary animate-spin", className)}
      width={size}
      height={size}
    />
  );
}
